var _defs, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSofi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "162.18959m",
    height: 42.862499,
    viewBox: "0 0 162.18959 42.862499",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 5.112,
    x2: 4.7909899,
    y1: 43.007,
    x1: 40.129002,
    id: "paint0_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop821",
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop823",
    stopColor: "#48494B",
    offset: 0.192
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop825",
    stopColor: "#313233",
    offset: 0.503
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop827",
    stopColor: "#0C0C0C",
    offset: 0.893
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop829",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", {
    id: "style851"
  }, ".cls-1{fill:#231f20;}.cls-2{fill:#0080c5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.036169,
    y1: 36.132832,
    x2: 36.132832,
    y2: 0.036169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop874",
    offset: 0,
    stopColor: "#0074f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop876",
    offset: 1,
    stopColor: "#03aaff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "24.218,17 0.792,17 0.792,0.539 24.218,0.539 ",
    id: "vector-svg@1x-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.104,1.319 0,1.319 0,0 1.104,0 ",
    id: "vector-svg@1x-c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.701,1.319 0.306,1.319 0.306,0 1.701,0 ",
    id: "vector-svg@1x-e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-54.181777,-93.254843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1256",
    transform: "matrix(1.9540914,0,0,1.936523,53.204731,91.383662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1222",
    d: "m 24.7,7.1 c -4.4,0 -8,3.6 -8,8 0,4.4 3.6,8 8,8 4.4,0 8,-3.6 8,-8 0,-4.4 -3.6,-8 -8,-8 z m 3.9,7.9 c 0,2.2 -1.7,4 -3.8,4 -2.1,0 -3.8,-1.8 -3.8,-4 0,-2.2 1.7,-4 3.8,-4 2.1,0 3.8,1.8 3.8,4 z M 52.7,7.4 C 52.6,7.3 52.5,7.3 52.4,7.3 h -3.2 c -0.2,0 -0.4,0.2 -0.4,0.4 v 14.5 c 0,0.1 0,0.2 0.1,0.3 0.1,0.1 0.2,0.1 0.3,0.1 h 3.2 c 0.2,0 0.4,-0.2 0.4,-0.4 V 7.7 c 0,-0.1 0,-0.2 -0.1,-0.3 z m -1.9,-2 C 52,5.4 53,4.4 53,3.2 53.1,2 52,1 50.8,1 c -1.2,0 -2.2,1 -2.2,2.2 0,1.3 1,2.2 2.2,2.2 z M 46.5,1.3 H 34.8 c -0.2,0 -0.4,0.2 -0.4,0.4 v 20.5 c 0,0.1 0,0.2 0.1,0.3 0.1,0.1 0.2,0.1 0.3,0.1 H 38 c 0.2,0 0.4,-0.2 0.4,-0.4 v -8.3 h 7.2 c 0.1,0 0.2,0 0.3,-0.1 C 46,13.7 46,13.6 46,13.5 v -3 c 0,-0.2 -0.2,-0.4 -0.4,-0.4 h -7.2 v -5 h 8.1 c 0.1,0 0.2,0 0.3,-0.1 0.1,-0.1 0.1,-0.2 0.1,-0.3 v -3 C 46.9,1.5 46.7,1.3 46.5,1.3 Z M 9.2,10.2 C 6,8.8 5,8.2 5,7 5,5.4 6.5,4.9 7.9,4.9 c 1.5,0 3.1,0.8 3.1,3 0,0.2 0.1,0.3 0.3,0.3 h 3.5 C 14.9,8.1 15,8 15,7.9 15,3.9 12.1,1 7.9,1 3.7,1 1,3.4 1,7 c 0,4.3 3.2,5.6 6.3,6.8 l 0.2,0.1 c 2.9,1.1 3.9,1.6 3.9,3 0,1.9 -2,2.2 -3.1,2.2 -2.1,0 -3.7,-1.5 -3.7,-3.5 V 15.4 C 4.6,15.2 4.5,15.1 4.3,15.1 H 0.8 c -0.1,0 -0.3,0.1 -0.3,0.3 v 0.3 c 0,4.4 3.2,7.4 7.7,7.4 4.3,0 7.2,-2.5 7.2,-6.1 0.1,-3.7 -1.8,-5 -6.2,-6.8 z M 83.5,22 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 0,-0.6 0.4,-1 1,-1 0.6,0 1,0.4 1,1 z m -1.8,0 c 0,0.5 0.3,0.8 0.8,0.8 0.5,0 0.8,-0.3 0.8,-0.8 0,-0.5 -0.3,-0.8 -0.8,-0.8 -0.5,0 -0.8,0.3 -0.8,0.8 z m 1.2,-0.2 c 0,0.1 -0.1,0.2 -0.2,0.3 l 0.2,0.4 h -0.3 l -0.2,-0.4 h -0.1 v 0.4 h -0.2 v -1 h 0.4 c 0.2,0 0.4,0.1 0.4,0.3 z M 82.4,21.7 V 22 h 0.1 c 0.1,0 0.2,-0.1 0.2,-0.1 0,-0.1 -0.1,-0.1 -0.2,-0.1 H 82.4 Z M 78.3,1.9 c 1.4,0 2.5,1.1 2.5,2.5 0,1.4 -1.1,2.5 -2.5,2.5 -1.4,0 -2.5,-1.1 -2.5,-2.5 0,-1.4 1.1,-2.5 2.5,-2.5 M 78.3,1 C 76.4,1 74.8,2.6 74.8,4.5 74.8,6.4 76.4,8 78.3,8 80.2,8 81.8,6.4 81.8,4.5 81.8,2.6 80.2,1 78.3,1 Z",
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1224",
    transform: "rotate(-28.538,78.28,12.007)",
    cx: 78.300003,
    cy: 12,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1226",
    transform: "rotate(-28.538,78.278,19.517)",
    cx: 78.300003,
    cy: 19.5,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1228",
    d: "m 70.8,9.5 c 0.7,0 1.3,0.3 1.8,0.7 0.5,0.5 0.7,1.1 0.7,1.8 0,1.4 -1.1,2.5 -2.5,2.5 -0.7,0 -1.3,-0.3 -1.8,-0.7 -0.5,-0.5 -0.7,-1.1 -0.7,-1.8 -0.1,-1.4 1.1,-2.5 2.5,-2.5 m 0,-1 c -1.9,0 -3.5,1.6 -3.5,3.5 0,1.9 1.6,3.5 3.5,3.5 1.9,0 3.5,-1.6 3.5,-3.5 0,-1.9 -1.6,-3.5 -3.5,-3.5 z",
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1230",
    transform: "rotate(-66.11,63.267,12.004)",
    cx: 63.299999,
    cy: 12,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1232",
    transform: "rotate(-66.11,70.777,4.494)",
    cx: 70.800003,
    cy: 4.5,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1234",
    transform: "rotate(-66.11,63.267,4.494)",
    cx: 63.299999,
    cy: 4.5,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse1236",
    transform: "rotate(-66.11,70.777,19.514)",
    cx: 70.800003,
    cy: 19.5,
    r: 3.5,
    style: {
      fill: "#00a2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1238",
    d: "m 63.3,17 c 0.7,0 1.3,0.3 1.8,0.7 0.5,0.5 0.7,1.1 0.7,1.8 0,1.4 -1.1,2.5 -2.5,2.5 -1.4,0 -2.5,-1.1 -2.5,-2.5 -0.1,-1.4 1.1,-2.5 2.5,-2.5 m 0,-1 c -1.9,0 -3.5,1.6 -3.5,3.5 0,1.9 1.6,3.5 3.5,3.5 1.9,0 3.5,-1.6 3.5,-3.5 0,-1.9 -1.6,-3.5 -3.5,-3.5 z",
    style: {
      fill: "#00a2c7"
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1000",
    type: "text/css"
  }, "\n\t.st0{fill:#E16A2D;}\n\t.st1{fill:#555759;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E16B2A;}\n")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofi);
export default __webpack_public_path__ + "static/media/sofi.c443800e1f39269d08c14a9c900a183d.svg";
export { ForwardRef as ReactComponent };